import type { MouseEvent } from 'react'

const INTERACTIVE = 'button, a, input, select, textarea, [role="menu"], [role="menuitem"], [role="listbox"], [role="option"]'

/**
 * El clic de una fila de lista: abrirla, salvo que el toque fuera a un mando de dentro.
 *
 * Toda la ficha abre, y el toque se recoge en la fila y no sólo en el bloque del
 * nombre: en el teléfono la zona sensible es un seudoelemento estirado sobre la
 * fila, y un toque en un hueco de ella —el relleno, los datos— no llegaba a abrir
 * nada. La casilla, la estrella, el estado, los enlaces y el menú siguen siendo
 * suyos. El bloque del nombre conserva su tecla Enter, pero ya no lleva clic
 * propio: subiría hasta aquí y abriría dos veces.
 */
export function openOnRowClick(open: () => void) {
  return (event: MouseEvent<HTMLElement>) => {
    if ((event.target as Element).closest(INTERACTIVE)) return
    open()
  }
}
